import PropTypes from "prop-types";
import React from "react";
import { Button } from "cxa-components";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";

const hraQuestionUrl = "/wellness/lifestyleAgeing/ageYourself/";

const HRACallToAction = ({ isShopEnabled, isForEnrolment, intl }) => {
  const className = isForEnrolment
    ? "apl-hra-cta--isEnrolment"
    : "apl-hra-cta--standard";
  let headerText = intl.formatMessage(messages.wantToSeeFutureDescription);
  let taglineText = intl.formatMessage(messages.howHealthyDescription);
  let contentText = intl.formatMessage(
    messages.withoutShopTakeQuestionnaireDescription
  );

  if (isShopEnabled) {
    headerText = intl.formatMessage(messages.tayloredOfferDescription);
    contentText = intl.formatMessage(
      messages.withShopTakeQuestionnaireDescription
    );
  }

  return (
    <article
      className={`apl-hra-cta ${className} card`}
      key={"HRACallToAction"}
    >
      <header>
        <h2>{headerText}</h2>
      </header>
      <section className="card__section--constrained">
        <div>
          <h4>{taglineText}</h4>
          <p>{contentText}</p>
          <p>
            <Button primary to={hraQuestionUrl}>
              {intl.formatMessage(messages.startNowDescription)}
            </Button>
          </p>
        </div>
        {!isForEnrolment && (
          <div>
            <figure>
              <img src="/assets/images/hra-cta-bg.png" alt="take-hra" />
            </figure>
          </div>
        )}
      </section>
    </article>
  );
};

HRACallToAction.propTypes = {
  intl: intlShape.isRequired,
  isForEnrolment: PropTypes.bool,
  isShopEnabled: PropTypes.bool,
};

export default injectIntl(HRACallToAction);



// WEBPACK FOOTER //
// ./components/dashboard/CallToAction.js